import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import React, { useState, useContext } from "react";
import { SidebarContext } from "context/SidebarContext";
import { notifySuccess, notifyError} from "utils/toast";
import ClientFeedbackServices from "services/ClientFeedbackServices";

import Tooltip from "@mui/material/Tooltip";
import FeedbackSmsModal from "components/modal/FeedbackSmsModal";
import { FaInfoCircle } from "react-icons/fa";
import ViewFeedbackModal from "components/modal/ViewFeedbackModal";
import { center } from "@cloudinary/url-gen/qualifiers/textAlignment";

const ClientFeedbackTable = ({ clientfeedback, perpage, currentPage ,tab}) => {
  const { setIsUpdate } = useContext(SidebarContext);

  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [showViewFeedbackModal, setShowViewFeedbackModal] = useState(false);
  
  // console.log("data from client page", clientfeedback);

  const closeModal = () => {
    setShowModal(false);
    setOpenModal(false);
    setSelectedData(null);
    // setError("");
  };

  const handleSendSms = async (payload) => {
    try {
      const response = await ClientFeedbackServices.sendFeedbackSms(
        selectedData.client_id,
        payload
      );
      // console.log("response data in parent", response);

      if (response?.status) {
        notifySuccess(response.message);
        setIsUpdate(true);
        closeModal();
      } else {
        // setError("Failed to update the feedback.");
        notifyError(response?.message || "Failed to update the feedback.");
      }
      return response;
    } catch (error) {
      console.error("API Error:", error);
      // setError("An error occurred while updating feedback.");
      notifyError(
    error?.response?.data?.message ||
    error?.message ||
    "An error occurred while updating feedback."
  );
  throw error;
    }
  };

  return (
    <>
      <FeedbackSmsModal
        isOpen={openModal}
        onClose={closeModal}
        handleSubmit={handleSendSms}
        error={error}
        selectedData={selectedData?.contact_no}
      />

      <ViewFeedbackModal
        isOpen={showViewFeedbackModal}
        onClose={() => setShowViewFeedbackModal(false)}
        data={selectedData}
      />

      <TableBody>
        {clientfeedback
          .slice((currentPage - 1) * perpage, currentPage * perpage)
          .map((data, index) => {
            const isFeedbackFilled =
              data?.query_driver ||
              data?.query_vehicle ||
              data?.query_depart ||
              data?.query_itinerary ||
              data?.driver_rating ||
              data?.vehicle_rating ||
              (data?.additional_comment &&
                data?.additional_comment.trim() !== "");
            return (
              <TableRow key={data.id}>
                <TableCell className="text-xs text-center">
                  {(currentPage - 1) * perpage + index + 1}
                </TableCell>
                <TableCell className="text-xs text-center">
                  {data.ref_no}
                  <div className="text-center pt-2 text-blue-400">
                  <span>{data.agent_ref_no}</span>
                </div>
                </TableCell>
                <TableCell>
                  <div className="flex flex-col items-center">
                    <span className="text-sm">{data.start_date}</span>
                    <span className="text-sm">{data.end_date}</span>
                  </div>
                </TableCell>

                <TableCell className="text-left">
                  <div className="text-sm text-left flex flex-col gap-4">
                    {/* Arrival Section */}
                    <div className="flex items-center justify-center gap-2">
                      <span className="text-green-500">A:</span>
                      <span>{data.arrival || "N/A"}</span>
                      {((data.arrival_via &&
                        data.arrival_via !== "Not Selected") ||
                        data.arrival_details ||
                        data.pickup_time) && (
                        <Tooltip
                          title={
                            <div className="text-xs">
                              <strong>Arrival Info:</strong>
                              <p>
                                Via:{" "}
                                {data.arrival_via &&
                                data.arrival_via !== "Not Selected"
                                  ? data.arrival_via
                                  : "N/A"}
                              </p>
                              <p>Details: {data.arrival_details || "N/A"}</p>
                              <p>Pickup Time: {data.pickup_time || "N/A"}</p>
                            </div>
                          }
                          placement="top"
                          componentsProps={{
                            tooltip: {
                              sx: { fontSize: "12px", padding: "8px" },
                            },
                          }}
                        >
                          <span
                            className="text-blue-500 cursor-pointer"
                            aria-label="View arrival details"
                          >
                            <FaInfoCircle />
                          </span>
                        </Tooltip>
                      )}
                    </div>
                    {/* {console.log(data)} */}
                    {/* Departure Section */}
                    <div className="flex items-center justify-center gap-2">
                      <span className="text-red-500">D:</span>
                      <span>{data.departure || "N/A"}</span>
                      {((data.departure_via &&
                        data.departure_via !== "Not Selected") ||
                        data.departure_details) && (
                        <Tooltip
                          title={
                            <div className="text-xs">
                              <strong>Departure Info:</strong>
                              <p>
                                Via:{" "}
                                {data.departure_via &&
                                data.departure_via !== "Not Selected"
                                  ? data.departure_via
                                  : "N/A"}
                              </p>
                              <p>Details: {data.departure_details || "N/A"}</p>
                            </div>
                          }
                          placement="top"
                          componentsProps={{
                            tooltip: {
                              sx: { fontSize: "12px", padding: "8px" },
                            },
                          }}
                        >
                          <span
                            className="text-blue-500 cursor-pointer"
                            aria-label="View departure details"
                          >
                            <FaInfoCircle />
                          </span>
                        </Tooltip>
                      )}
                    </div>
                  </div>
                </TableCell>

                <TableCell>
                  <div className="text-sm flex flex-col items-center space-y-3">
                    <Tooltip
                                        title={data.client_number || "No mobile"}
                                        arrow
                                      >
                                        {data.client_name}
                                      </Tooltip>

                    <div
                      className="flex items-center gap-1 cursor-pointer"
                      onClick={() => {
                        setOpenModal(true);
                        setSelectedData(data);
                      }}
                    >
                      <span className="text-green-500">Feedback SMS</span>

                      {data?.feedback_sent_by_name && (
                        <Tooltip
                          title={`Sent By: ${data.feedback_sent_by_name}`}
                          arrow
                        >
                          <span className="inline-flex items-center">
                            <FaInfoCircle className="text-blue-500" />
                          </span>
                        </Tooltip>
                      )}
                    </div>
                  <div className="text-center pt-2 text-blue-400">
                    <span>{data.company_name}</span>
                    </div>
                  </div>
                </TableCell>

               {tab === 1 &&  <TableCell className="text-sm text-center">
                  <span
                    onClick={() => {
                      if (isFeedbackFilled) {
                        setSelectedData(data);
                        setShowViewFeedbackModal(true); // open modal
                      }
                    }}
                    // className="cursor-pointer"
                    style={{
                      color: isFeedbackFilled ? "green" : "red",
                          cursor: isFeedbackFilled ? "pointer" : "default"
                    }}
                  >
                    {isFeedbackFilled ? "View" : "Not Updated"}
                  </span>
                </TableCell>}

                <TableCell className="text-sm text-center">
                  <span className="text-sm">{data.days_to_complete}</span>
                </TableCell>

                <TableCell className="text-sm text-center">
                  <div className="text-sm flex flex-col items-center space-y-3">
                  <span>{data.package_type}</span>
                  <Tooltip title={data.seller_mobile || "No mobile"} arrow>
                                      <span className="text-center pt-2 text-blue-400">{data.seller}</span>
                                    </Tooltip>
                  </div>
                </TableCell>
              
                <TableCell className="text-sm text-center">
                  <Tooltip title={data.vehicle_remark}>
                    <span>{data.vehicle_remark ? `Remark` : "-"}</span>
                  </Tooltip>
                </TableCell>
              </TableRow>
            );
          })}
      </TableBody>
    </>
  );
};

export default ClientFeedbackTable;
